export const initialState = {
  actionProcessing: false,  
  notificationsVisible: false,
  countOfNewNotifications: 0,
  notifications: [],
};
